import React from 'react';
import LegalLayout from '../components/common/LegalLayout';

const PrivacyPolicyPage = () => (
  <LegalLayout
    title="개인정보 처리방침"
    subtitle="ElectroWave Club은 학생과 멘토의 개인정보를 신중하게 다루며, 매칭과 운영에 꼭 필요한 범위 안에서만 수집·이용합니다."
    helmetDescription="ElectroWave Club 개인정보 처리방침 — 수집 항목, 이용 목적, 보유 기간, 제3자 제공, 정보주체의 권리 등."
    accentColor="#6366f1"
  >
    <p>
      ElectroWave Club(이하 "클럽")은 「개인정보 보호법」을 준수하며, 학생과 멘토의 개인정보를 보호하기 위해
      다음과 같은 처리방침을 두고 있습니다.
    </p>

    <h2>1. 수집하는 개인정보 항목</h2>
    <p>
      클럽은 매칭과 운영에 필요한 최소한의 정보만 수집합니다.
    </p>
    <ul>
      <li>
        <strong>필수</strong> — <strong>이름(또는 닉네임)</strong>, <strong>이메일 주소</strong>,{' '}
        <strong>학습 목표/현재 수준 자기 기술</strong>
      </li>
      <li>
        <strong>선택</strong> — <strong>휴대전화 번호</strong>(긴급 연락 시),{' '}
        <strong>소속(학교/회사)</strong>, <strong>GitHub 아이디</strong>,{' '}
        <strong>Zoom용 프로필 이미지(AI 생성 아바타 권장)</strong>
      </li>
      <li>
        <strong>결제 시</strong> — <strong>입금자명</strong> (학생→멘토 직접 입금이므로 별도 결제정보는
        수집하지 않습니다)
      </li>
      <li>
        <strong>학습 진행 중</strong> — <strong>정기 미팅 녹화본(영상·음성)</strong>,{' '}
        <strong>채팅 로그</strong>, <strong>제출한 코드·문서</strong>
      </li>
      <li>
        <strong>자동 수집</strong> — <strong>접속 로그(IP, 브라우저 종류)</strong>,{' '}
        <strong>쿠키</strong> (서비스 이용 통계 목적)
      </li>
    </ul>

    <h2>2. 개인정보의 이용 목적</h2>
    <ul>
      <li>학생-멘토 매칭 및 학습 진행</li>
      <li>회비 결제 및 환불 처리</li>
      <li>공지사항·매칭 결과 등 필수 안내 발송</li>
      <li>본인 동의 시 후기 게재 및 마케팅 정보 발송</li>
      <li>법령상 의무 이행 (전자상거래법, 세무 관련 등)</li>
    </ul>

    <h2>3. 보유 및 이용 기간</h2>
    <p>
      개인정보는 수집·이용 목적이 달성되면 지체 없이 파기합니다. 다만, 관련 법령에 따라 보존이 필요한 경우
      해당 기간 동안 보관합니다.
    </p>
    <ul>
      <li><strong>회원 정보(이름, 이메일 등)</strong>: 회원 탈퇴 또는 매칭 종료 후 1년</li>
      <li><strong>정기 미팅 녹화본 / 채팅 로그</strong>: 매칭 종료 후 1년 (학습 복기 및 분쟁 대응 목적)</li>
      <li><strong>결제 및 거래 기록</strong>: 5년 (전자상거래법)</li>
      <li><strong>접속 로그</strong>: 3개월 (통신비밀보호법)</li>
    </ul>

    <h2>4. 개인정보의 제3자 제공</h2>
    <p>
      클럽은 학생과 멘토의 개인정보를 외부에 제공하지 않습니다. 다만 다음의 경우에는 예외로 합니다.
    </p>
    <ul>
      <li>본인이 사전에 동의한 경우 (예: 매칭된 멘토에게 학생 자기 기술 공유)</li>
      <li>법령에 의거하거나 수사기관의 요청이 있는 경우</li>
    </ul>

    <h2>5. 개인정보 처리의 위탁</h2>
    <p>
      서비스 운영을 위해 다음과 같은 외부 서비스에 개인정보 처리를 위탁할 수 있습니다.
    </p>
    <table>
      <thead>
        <tr>
          <th>수탁사</th>
          <th>위탁 업무</th>
          <th>처리 항목</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td data-label="수탁사">Google Firebase</td>
          <td data-label="위탁 업무">웹사이트 호스팅 / 인증</td>
          <td data-label="처리 항목"><strong>접속 로그</strong>, <strong>인증 토큰</strong></td>
        </tr>
        <tr>
          <td data-label="수탁사">이메일 서비스 (Proton Mail)</td>
          <td data-label="위탁 업무">안내 이메일 발송</td>
          <td data-label="처리 항목"><strong>이메일 주소</strong>, <strong>이름</strong></td>
        </tr>
        <tr>
          <td data-label="수탁사">화상 미팅 서비스 (Zoom / Google Meet)</td>
          <td data-label="위탁 업무">정기 미팅 진행</td>
          <td data-label="처리 항목"><strong>이름</strong>, <strong>이메일</strong></td>
        </tr>
      </tbody>
    </table>

    <h2>6. 정보주체의 권리와 행사 방법</h2>
    <p>
      학생·멘토는 언제든 자신의 개인정보에 대해 다음 권리를 행사할 수 있습니다.
    </p>
    <ul>
      <li><strong>열람 요청</strong></li>
      <li><strong>정정·삭제 요청</strong></li>
      <li><strong>처리 정지 요청</strong></li>
      <li><strong>동의 철회</strong></li>
    </ul>
    <p>
      위 권리는 이메일(firstman9@protonmail.com)을 통해 행사할 수 있으며, 클럽은 지체 없이 조치합니다.
    </p>

    <h2>7. 개인정보의 안전성 확보 조치</h2>
    <ul>
      <li>접근 권한 최소화: 운영자 본인 이외 접근 금지</li>
      <li>전송 구간 암호화 (HTTPS)</li>
      <li>저장된 개인정보의 정기 점검 및 불필요한 정보 파기</li>
    </ul>

    <h2>8. 쿠키의 사용</h2>
    <p>
      웹사이트는 사용자 경험 개선을 위해 최소한의 쿠키를 사용합니다. 브라우저 설정에서 쿠키 저장을 거부할 수
      있으며, 거부 시 일부 기능 이용에 제한이 있을 수 있습니다.
    </p>

    <h2>9. 개인정보 보호책임자</h2>
    <ul>
      <li>이름: ElectroWave Club 운영자</li>
      <li>이메일: firstman9@protonmail.com</li>
    </ul>

    <h2>10. 변경 고지</h2>
    <p>
      본 처리방침의 내용 추가·삭제·수정이 있을 경우 변경 사항을 시행 7일 전에 본 페이지를 통해 공지합니다.
    </p>

    <p style={{ marginTop: 32, fontSize: 13, color: '#666' }}>
      본 개인정보 처리방침은 2026년 5월 3일부터 적용됩니다.
    </p>
  </LegalLayout>
);

export default PrivacyPolicyPage;
